exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".heading-1[data-v-0142afcc]{margin-bottom:0!important}.bordergrey[data-v-0142afcc]{border:1px solid #979797;border-radius:15px}.hotel-selected[data-v-0142afcc]{border:2px solid #000}.fixed-top[data-v-0142afcc]{position:fixed;top:30px;transition:top .4s ease}", ""]);

// exports
